import { useEffect, useRef, useCallback } from "react";
import Cookies from "js-cookie";
import { useGetCurrentUserQuery } from "../redux/services/authApi";

// Keeps the auth user fresh — and therefore user.company.subscription_status —
// by refetching GET /me on mount, every 5 minutes, on tab focus, and on any
// user interaction (click/keydown), throttled to once per 30s. /me returns the
// same shape as /login and already dispatches setAuthUser on success, so this
// hook just needs to trigger the refetch; no separate expiry logic is needed.
export const useSubscriptionGuard = () => {
  const token = Cookies.get("token");
  const lastRefetchAt = useRef(0);

  const { refetch } = useGetCurrentUserQuery(undefined, {
    skip: !token,
    pollingInterval: 5 * 60 * 1000,
    refetchOnFocus: true,
  });

  const throttledRefetch = useCallback(() => {
    const now = Date.now();
    if (now - lastRefetchAt.current < 30_000) return;
    lastRefetchAt.current = now;
    refetch();
  }, [refetch]);

  useEffect(() => {
    if (!token) return;
    const events: string[] = ["click", "keydown"];
    events.forEach((e) => document.addEventListener(e, throttledRefetch));
    return () => events.forEach((e) => document.removeEventListener(e, throttledRefetch));
  }, [token, throttledRefetch]);
};
